import { render, staticRenderFns } from "./MsgAffix.vue?vue&type=template&id=7e7490b6&scoped=true&"
import script from "./MsgAffix.vue?vue&type=script&lang=js&"
export * from "./MsgAffix.vue?vue&type=script&lang=js&"
import style0 from "./MsgAffix.vue?vue&type=style&index=0&id=7e7490b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7490b6",
  null
  
)

export default component.exports